function TrackMyOrderService(Restangular) {
    this._api = Restangular.one('/TrackMyOrder');
    this._restangular = Restangular;
}

TrackMyOrderService.prototype.getOrders = function () {
    return this._api.get();
};

TrackMyOrderService.prototype.getOrderInfo = function (orderId) {
    return this._restangular.one('/TrackMyOrder', orderId).get();
};


module.exports = TrackMyOrderService;



// WEBPACK FOOTER //
// ./src/shop/trackmyorder/trackmyorder.service.js